import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from './store'
import axios from 'axios';

import { apis } from './core/apis';
import * as appUtils from './core/appUtils';
import {ConstStatic} from './core/constStatic';
import {HttpServer} from './core/http.server';
import '@/core/lazy_lib/components_use'
import './components/global.less';
import  './permission';

import { Dialog } from '@/components';

import { FormModel } from 'ant-design-vue';
Vue.use(FormModel);

Vue.config.productionTip = false;
Vue.prototype.axios = axios;

Vue.prototype.apis = apis.api;
Vue.prototype.appUtils = appUtils;
Vue.prototype.constStatic = ConstStatic;
Vue.prototype.http = HttpServer;

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
